import { render, staticRenderFns } from "./LiveAuctionItemCard.vue?vue&type=template&id=206117ce&scoped=true&"
import script from "./LiveAuctionItemCard.vue?vue&type=script&lang=js&"
export * from "./LiveAuctionItemCard.vue?vue&type=script&lang=js&"
import style0 from "./LiveAuctionItemCard.vue?vue&type=style&index=0&id=206117ce&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "206117ce",
  null
  
)

export default component.exports